import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MapSettings } from "app/models/settings/map-settings";
import { environment } from "environments/environment";
import { catchError, map } from "rxjs/operators";
import { Observable, throwError as observableThrowError } from 'rxjs';

@Injectable()
export class MapsService {

    private mapSettingsUrl = `${environment.baseUrl}api/mapsettings`;
    
    constructor(private httpClient: HttpClient) { }

    public getUserMapSettings(): Observable<MapSettings> {
        let url: string = `${this.mapSettingsUrl}`;
        return this.httpClient.get(url)
        .pipe(map((response: MapSettings) => {
            return response;
        }),
        catchError(error => observableThrowError(error)));
    }

    public updateUserMapSettings(data: MapSettings) {
        let url: string = `${this.mapSettingsUrl}`;
    
        return this.httpClient.post(url, data)
             .pipe(catchError(error => observableThrowError(error)));
    }
}